/* eslint-disable import/no-named-as-default */
import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import {DFPManager, AdSlot} from 'react-dfp';
import axios from 'axios';
import HomePage from './HomePage';
import MobileSearch from './MobileSearch';
import MobileRaceHome from './MobileRaceHome';
import MobileResults from './MobileResults';
import MobileDivisionResults from './MobileDivisionResults';
import Favorites from './Favorites';
import Runner from './Runner';
import NotFoundPage from './NotFoundPage';
import Loading from './Loading';
import Unathorized from './Unauthorized';
import {setIsMobile, addAPIKeyToHeader} from '../actions/race';

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.

const MOBILE_WIDTH = 500;

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      isMobile: true,
      houseAd: null,
      houseAdCounter: 0
    };

    this.handleWindowSizeChange(true, props);
  }

  houseAdInterval = null;
  adsenseAdInterval = null;

  componentWillUpdate(newProps) {
    if (this.state.isMobile !== newProps.isMobile) {
      this.setState({isMobile: newProps.isMobile});
    }
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange.bind(this));
    window.addEventListener('orientationchange', this.handleWindowSizeChange.bind(this));



    // window.setInterval(function refreshAds() { DFPManager.refresh(); }, 15000);
    //
    // DFPManager.load();


    const _this = this;

    if (this.props.ads && this.props.ads.type === 'adsense') {

      this.adsenseAdInterval = setInterval(() => {

        // console.log('Calling Refresh');
        DFPManager.refresh();

      }, 30000);


    } else if (this.props.ads && this.props.ads.showMobile && this.props.ads.type === 'house') {

      this.fetchHouseAd();

      this.houseAdInterval = setInterval(() => {
        _this.fetchHouseAd();
      }, 20000);

    }



  }

  fetchHouseAd() {
    const _this = this;

    if (this.props.accountId) {
      axios.get('https://api.v2.raceresults360.com/v2/ad/random', addAPIKeyToHeader(() => {return {rr360: {accountId: this.props.accountId}}; }))
        .then((result) => {
          _this.setState({houseAd: result.data});
        })
    }
  }

// make sure to remove the listener
// when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange.bind(this));
    window.removeEventListener('orientationchange', this.handleWindowSizeChange.bind(this));

    if (this.adsenseAdInterval) {
      clearInterval(this.adsenseAdInterval);
    }
    if (this.houseAdInterval) {
      clearInterval(this.houseAdInterval);
    }
  }

  handleWindowSizeChange(initial = false, props = null){

    const _this = this;

    setTimeout(() => {

      if (!initial) {
        this.setState({width: window.innerWidth, isMobile: true});
      }
      const leProps = props || this.props;

      if (window.innerWidth <= MOBILE_WIDTH !== leProps.isMobile) {

        // console.log(window.innerWidth);

        leProps.setIsMobile(true);
      } else if (window.innerWidth > MOBILE_WIDTH && leProps.isMobile) {

        leProps.setIsMobile(true);
      }
    }, 200);
  }

  componentDidMount() {
    const elem = document.querySelector('base');
    if (elem) {
      elem.setAttribute('href', document.location.origin + document.location.pathname);
    }

  }

  handleMobileBodyScroll(e) {
    // console.log(e.target.scrollTop);
    // console.log(e.target.scrollHeight);
    //
    if (!this.state.scrollShowMore && (e.target.scrollTop + e.target.offsetHeight > e.target.scrollHeight - 45 * 10)) {
      // console.log('Yo!');
      this.setState({scrollShowMore: true});
    }
  }

  resetScrollShowMore() {
    const _this = this;
    setTimeout(() => {
      // console.log('Reset!');
      _this.setState({scrollShowMore: false});
    }, 1000);
  }

  renderHeader() {


    const isRR360 = this.props.accountId.toLowerCase() === 'rr360';
    const isRR360Brand = this.props.brand.toLowerCase() === 'rr360';
    const headerPadding = isRR360 ? 0 : 15;


    return (<div className="logo-wrap">
      <h1 className={isRR360Brand ? 'logo rr360' : 'logo'} style={{backgroundColor: this.props.theme.secondaryColor, width: '100%', height: this.props.theme.headerHeight + headerPadding + 'px', textAlign: 'center'}} >
        {true || this.props.singleEvent ? (
          <img src={this.props.theme.logo} style={{height: this.props.theme.headerHeight + 'px', width: 'auto'}} />
        ): (
          <a href="#" ><img src={this.props.theme.logo} style={{height: this.props.theme.headerHeight + 'px', width: 'auto'}} /></a>
        )}
      </h1>
    </div>);
  }

  render() {

    // console.log(document.referrer);
    // console.log(this.state);
    // console.log(this.state.houseAd);
    if (!this.props.accountId) {
      return (
        <Loading />
      );
    }


    const isRR360 = this.props.accountId.toLowerCase() === 'rr360';
    const isRR360Brand = this.props.brand.toLowerCase() === 'rr360';
    const headerPadding = isRR360 ? 0 : 15;


    if (this.props.unathorized) {
      return (
        <div id="bodies">
          {this.renderHeader()}
          <Unathorized />
        </div>
      );
    }

      return(
        <div id="bodies">
          {this.renderHeader()}
          <div onScroll={this.handleMobileBodyScroll.bind(this)} className="body" style={{top: this.props.theme.headerHeight + headerPadding + 'px'}}>
            <Switch>
              <Route exact path="/" component={HomePage}/>
              <Route exact path="/race/:raceId" component={MobileRaceHome}/>
              <Route exact path="/race/:raceId/" component={MobileRaceHome}/>
              <Route exact path="/race/:raceId//" render={(props) => <MobileRaceHome noEvent {...props} />}/>
              <Route exact path="/race/:raceId//search" component={MobileSearch}/>
              <Route exact path="/race/:raceId//results" component={MobileResults}/>
              <Route exact path="/race/:raceId//results/:division" render={(props) => <MobileDivisionResults scrollShowMore={this.state.scrollShowMore} resetScrollShowMore={this.resetScrollShowMore.bind(this)} {...props} />} />
              <Route exact path="/race/:raceId//favorites" component={Favorites}/>
              <Route exact path="/race/:raceId/search" component={MobileSearch}/>
              <Route exact path="/race/:raceId/results" component={MobileResults}/>
              <Route exact path="/race/:raceId/results/:division" render={(props) => <MobileDivisionResults scrollShowMore={this.state.scrollShowMore} resetScrollShowMore={this.resetScrollShowMore.bind(this)} {...props} />} />
              <Route exact path="/race/:raceId/favorites" component={Favorites}/>
              <Route exact path="/race/:raceId/:eventId" component={MobileRaceHome}/>
              <Route exact path="/race/:raceId/:eventId/" component={MobileRaceHome}/>
              <Route exact path="/race/:raceId/:eventId/search" component={MobileSearch}/>
              <Route exact path="/race/:raceId/:eventId/results" component={MobileResults}/>
              <Route exact path="/race/:raceId/:eventId/results/" component={MobileResults}/>
              <Route exact path="/race/:raceId/:eventId/results/:division" render={(props) => <MobileDivisionResults scrollShowMore={this.state.scrollShowMore} resetScrollShowMore={this.resetScrollShowMore.bind(this)} {...props} />} />
              <Route exact path="/race/:raceId/:eventId/favorites" component={Favorites}/>

              <Route exact path="/race/:raceId/:eventId/:bib" component={Runner}/>
              <Route exact path="/race/:raceId//:bib" component={Runner}/>
              <Route component={NotFoundPage}/>
            </Switch>
          </div>
          <div className="footer">
            <p className="about">Race Results 360 <a href={document.referrer !== "" ? `${document.referrer}${window.location.hash}` : `https://app.raceresults360.com/${window.location.hash}`} id="full_website">Full Website</a></p>

            {this.props.ads && this.props.ads.showMobile && this.props.ads.type === 'adsense' &&
              <div style={{textAlign: "center"}}>
                <AdSlot sizes={[[320,50]]}
                        dfpNetworkId='15308329'
                        adUnit='MDOT'
                  // targetingArguments={ {'customKw': 'test'} }
                  // sizeMapping={ [ {viewport: [1024, 768], sizes:[[728, 90], [300, 250]]},
                  //   {viewport: [900, 768], sizes:[[300, 250]] }] }
                  //       onSlotRender={this.loadSecondaryAd}
                  /* never refresh this adSlot */
                        shouldRefresh={ ()=> true }
                />
              </div>
            }

            {this.props.ads && this.props.ads.showMobile && this.props.ads.type === 'house' && this.state.houseAd &&
            <div style={{textAlign: "center"}}>
              <div className="ad-space">
                {this.state.houseAd.click_link ? (
                  <a href={this.state.houseAd.click_link} target="_blank"><img src={`https://admin.cdn.raceresults360.com/${this.state.houseAd.file_name}`} width="350" heigh="48" /></a>
                ) : (
                  <img src={`https://admin.cdn.raceresults360.com/${this.state.houseAd.file_name}`} width="350" heigh="48" />
                )}
              </div>
            </div>
            }





          </div>
        </div>

      );


  }
}

App.propTypes = {
  children: PropTypes.element
};

function mapStateToProps(state) {
  return {
    isMobile: state.rr360.isMobile,
    ads: state.rr360.ads,
    brand: state.rr360.brand,
    accountId: state.rr360.accountId,
    theme: state.rr360.theme,
    singleEvent: state.rr360.singleEvent,
    unathorized: state.rr360.unathorized
  };
}


export default withRouter(connect(mapStateToProps, {setIsMobile})(App));



// WEBPACK FOOTER //
// ./src/components/App.js